// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_6c97079b1b--wrapper--_fYPD","quiz_completed":"_6c97079b1b--quiz_completed--DrBqe","container":"_6c97079b1b--container--ZPpnJ"};